(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hoito-collection-card-hover"] && !Shopify.designMode) return;
  try {
    // HOİTO localStorage tabanlı favori (istek listesi) butonu.
  // Sunucu gerektirmez; favori ürün id'lerini tarayıcıda saklar.
  if (!customElements.get('hoito-fav-button')) {
    customElements.define(
      'hoito-fav-button',
      class extends HTMLElement {
        connectedCallback() {
          this.storageKey = 'hoito_wishlist';
          this.productId = this.dataset.id;
          this.button = this.querySelector('.hoito-fav__btn');
          if (!this.button || !this.productId) return;
          this.sync();
          this.button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.toggle();
          });
        }

        read() {
          try {
            const raw = localStorage.getItem(this.storageKey);
            const list = raw ? JSON.parse(raw) : [];
            return Array.isArray(list) ? list : [];
          } catch (error) {
            return [];
          }
        }

        write(list) {
          try {
            localStorage.setItem(this.storageKey, JSON.stringify(list));
          } catch (error) {
            /* depolama kullanılamıyor — sessizce yoksay */
          }
        }

        isFavorite() {
          return this.read().includes(this.productId);
        }

        sync() {
          const active = this.isFavorite();
          this.classList.toggle('is-active', active);
          this.button.setAttribute('aria-pressed', active ? 'true' : 'false');
        }

        toggle() {
          let list = this.read();
          if (list.includes(this.productId)) {
            list = list.filter((id) => id !== this.productId);
          } else {
            list.push(this.productId);
          }
          this.write(list);
          this.sync();
          document.dispatchEvent(
            new CustomEvent('hoito:wishlist:change', {
              detail: { productId: this.productId, favorite: this.isFavorite() },
            })
          );
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
